<template>
    <!--
      	作者：bbc_team
      	时间：2023-06-08
      	描述：平台活动-列表
      -->
    <div>
        <div class="common-level-rail">
            <el-button size="small" type="info" icon="el-icon-back" @click="$router.back()">返回</el-button>
            <el-button size="small" type="primary" icon="el-icon-plus" @click="add">添加问答</el-button>
        </div>
        <div class="table-wrap">
            <el-table v-loading="loading" :data="tableData" style="width: 100%">
                <el-table-column prop="question_id" label="问题ID" width="100"></el-table-column>
                <el-table-column prop="question" label="问题"></el-table-column>
                <el-table-column prop="sort" label="排序" width="100"></el-table-column>
                <el-table-column prop="status" label="状态" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1" class="green">显示</span>
                        <span v-if="scope.row.status == 0" class="gray">隐藏</span>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="添加时间" width="140"></el-table-column>
                <el-table-column prop="update_time" label="更新时间" width="140"></el-table-column>
                <el-table-column prop="name" label="操作" width="90">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="editItem(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" @click="deleteItem(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!--分页-->
            <div class="pagination">
                <el-pagination
                    background
                    :current-page="curPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="totalDataNumber"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import PlatformActivityApi from "@/api/platformactivity.js";
    export default {
        components: {},
        data() {
            return {
                /*分类*/
                categoryData: [],
                /*表单数据*/
                tableData: [],
                /*是否打开添加弹窗*/
                open_add: false,
                /*是否打开编辑弹窗*/
                open_edit: false,
                /*当前编辑的对象*/
                userModel: {},
                commentData: [],
                loading: true,
                pageSize: 20,
                totalDataNumber: 0,
                curPage: 1
            };
        },
        created() {
            /*获取平台活动列表*/
            this.getData();
        },
        methods: {
            /*获取平台活动列表*/
            getData() {
                let self = this;
                let Params = {};
                Params.page = self.curPage;
                Params.list_rows = self.pageSize
                self.loading = true
                PlatformActivityApi.question.list(Params, true)
                    .then((data) => {
                        self.loading = false;
                        self.tableData = data.data.list.data;
                        self.totalDataNumber = data.data.list.total;
                    })
                    .catch((error) => {
                        self.loading = false;
                    });
            },

            /*添加平台活动*/
            add() {
                let self = this;
                this.$router.push({
                    path: "/platformactivity/question/add",
                    query: {
                        activity_id: self.$route.query.activity_id
                    }
                });
            },

            /*编辑平台活动*/
            editItem(row) {
                let self = this;
                let params = row.question_id;
                this.$router.push({
                    path: "/platformactivity/question/edit",
                    query: {
                        activity_id: self.$route.query.activity_id,
                        question_id: params,
                    }
                });
            },

            /*选择第几页*/
            handleCurrentChange(val) {
                this.curPage = val;
                this.loading = true;
                this.getData();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.getData();
            },

            /*删除平台活动*/
            deleteItem(row) {
                let self = this;
                self.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        self.loading = true;
                        PlatformActivityApi.question.delete(
                            {
                                question_id: row.question_id
                            },
                            true
                        )
                            .then((data) => {
                                self.$message({
                                    message: data.msg,
                                    type: "success"
                                });
                                self.loading = false;
                                self.getData();
                            })
                            .catch((error) => {});
                    })
                    .catch(() => {});
            },

            handleClick(tab, event) {},

            /*关闭弹窗*/
            closeDialogFunc(e, f) {
                if (f == "add") {
                    this.open_add = e.openDialog;
                    if (e.type == "success") {
                        this.getData();
                    }
                }
                if (f == "edit") {
                    this.open_edit = e.openDialog;
                    if (e.type == "success") {
                        this.getData();
                    }
                }
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/platformactivity/question/index.vue